module.exports = "/public/assets/img/vray-icon.svg";